export default __webpack_public_path__ + "static/media/skill3.824a8745.svg";